import { MapCoordinates } from '@freelancer/datastore/core';
import { Country } from '../countries';
import {
  CountryCode,
  generateCountryObjects,
} from '../countries/countries.mock';
import { Location } from './location.model';

interface GenerateLocationOptions {
  readonly country?: Country;
  readonly city?: string;
  readonly mapCoordinates?: MapCoordinates;
  readonly vicinity?: string;
  readonly administrativeArea?: string;
  readonly fullAddress?: string;
}

export function generateLocationObject({
  country = generateCountryObjects({ countryCodes: [CountryCode.US] })[0],
  city = 'Chicago',
  mapCoordinates = {
    latitude: 41.876,
    longitude: -87.64,
  },
  vicinity = 'Chicago',
  administrativeArea,
  fullAddress = '525 W. Van Buren, Suite 1100, Chicago IL 60607',
}: GenerateLocationOptions = {}): Location {
  return {
    country,
    city,
    mapCoordinates,
    vicinity,
    administrativeArea,
    fullAddress,
  };
}
